import { Injectable } from "@angular/core";
import { BreadcrumbModel } from "@modules/common/models/BreadcrumbModel";
import { CurrentCaseService } from "@modules/common/services/current-case.service";
import { CurrentEnvironmentService } from "@modules/common/services/current-environment.service";
import { HomeUrlService } from "@modules/common/services/home-url.service";

@Injectable({
    providedIn: 'root'
})
export class AdminPortalConfigBreadcrumbsService {
	constructor(private _currentCaseService: CurrentCaseService,
		private _currentEnvironmentService: CurrentEnvironmentService,
		private _homeUrlService: HomeUrlService) { }

    public getBreadcrumbsModel(args: { currentPageTitle?: string, currentPageRouteName?: string }): BreadcrumbModel[] {
        const result = [{
            title: 'Case Config',
			url: this._homeUrlService.getHomeUrl()
        }];

        if (args.currentPageRouteName) {
            result.push({
                title: args.currentPageTitle || args.currentPageRouteName,
                url: this.getUrl(args.currentPageRouteName)
            });
        }

        return result;
    }

    private getUrl(page: string): string {
        return '/' + this._currentEnvironmentService.getCurrentEnvironmentName() + '/' + this._currentCaseService.getCurrentCaseName() + '/AdminPortalConfig/' + page;
    }

}
